import React, { useMemo, useState } from "react";
import stopIcon from "../../../../assets/stop.svg";
import Carousel from "react-grid-carousel";

import { Button } from "../../../../components/Button/Button";
import { Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { http } from "../../../../utils/httpCommon";
import DeleteModalBooking from "../../../../components/DeleteModal/DeleteModalBooking";
import ConfirmShowBooking from "../../../../components/Modal/confirmShowBoooking";
import ModalComponent from "../../../../components/Modal/Modal2";
import CalendarFormStep2 from "../Forms/CalendarFormStep2";
import { useAuthUser } from "react-auth-kit";
import { useEffect } from "react";
import { useTimeSelection } from "../../../../hooks/useTimeSelection";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Switch, TextField } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { classes, diff_hours } from "../Forms/CalendarForm";
import { prettyNumber } from "../../../../lib/prettyNumber";
import dayjs from "dayjs";
import ImageUploader from "../../../../components/ui/image-uploader";

// Utility functions to separate images from documents
const isImageFile = (url) => {
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg"];
  const lowerUrl = url.toLowerCase();
  return imageExtensions.some((ext) => lowerUrl.includes(ext));
};

const getFileExtension = (url) => {
  const urlWithoutParams = url.split("?")[0];
  const lastDotIndex = urlWithoutParams.lastIndexOf(".");
  return lastDotIndex !== -1 ? urlWithoutParams.substring(lastDotIndex + 1).toUpperCase() : "FILE";
};

const getFileName = (url) => {
  const urlWithoutParams = url.split("?")[0];
  const lastSlashIndex = urlWithoutParams.lastIndexOf("/");
  const fileName =
    lastSlashIndex !== -1 ? urlWithoutParams.substring(lastSlashIndex + 1) : urlWithoutParams;
  return fileName.length > 20 ? fileName.substring(0, 20) + "..." : fileName;
};
const BookingsDetails = ({
  responseData: ogRespone,
  getOpenAppointmentData,
  selectedTimeSlotData,
  open,
  close,
  facilities,
  paymentMethods,
  fetchAppointmentsData,
  selectedAppointment,
  fetchThisAppointmentData,
  onSelectBookingDay,
  day: currentDay,
}) => {
  const [steps, setSteps] = useState(0);
  const [responseData, setResponseDate] = useState(ogRespone);
  const [selectedDayIdForPayment, setSelectedDayIdForPayment] = useState(null);
  const auth = useAuthUser();
  const userRole = auth()?.role;
  const canDeleteBookings = ["Super Admin", "Branch Manager", "Area Manager"].includes(
    userRole || ""
  );
  
  // sync responseData when ogRespone changes (after delete/edit)
  useEffect(() => {
    setResponseDate(ogRespone);
  }, [ogRespone]);
  
  

  const calculateTotalPaid = () => {
    let totalPaid = 0;
    for (const transaction of responseData?.transactions || []) {
      totalPaid += Number(transaction?.amount) || 0;
    }
    // Subtract refunded amounts to get effective paid amount
    // When days are refunded, that money is no longer "paid" for the booking
    const totalRefunded = Number(responseData?.totalRefunded) || 0;
    const effectivePaid = totalPaid - totalRefunded;
    return Math.ceil(Math.max(0, effectivePaid)); // Ensure non-negative
  };
  const totalPaid = useMemo(() => calculateTotalPaid(), [responseData?.transactions, responseData?.totalRefunded]);
  
  // Calculate paid amount per day based on transactions
  // CRITICAL: Preserve existing payments when days are added/edited
  // Key principle: Payments should only be allocated to days that existed when payment was made
  // CRITICAL: Account for refunds - use effectivePaid (totalPaid - totalRefunded) instead of raw transaction total
  // NEW: Prioritize explicit dayId transactions, then allocate remaining proportionally
  const calculatePaidPerDay = useMemo(() => {
    const paidPerDay = {};
    const allDays = responseData?.days || [];
    
    // Simply read the stored paidAmount from each day (new system)
    allDays.forEach((day) => {
      paidPerDay[day._id] = Number(day.paidAmount) || 0;
    });
    
    return paidPerDay;
  }, [responseData?.days]);

  const dayFinancials = useMemo(() => {
    const result = {};
    const days = responseData?.days || [];
    const bookingTotal = Number(responseData?.totalAmount) || 0;
    const bookingSubTotal = Number(responseData?.subTotal) || 0;
    const totalDuration = days.reduce((sum, day) => sum + (day.endTime - day.startTime), 0) || 0;

    let accumulatedTotal = 0;
    let accumulatedSubTotal = 0;

    days.forEach((day, index) => {
      const isLastDay = index === days.length - 1;
      const ratio = totalDuration > 0 ? (day.endTime - day.startTime) / totalDuration : 0;

      let dayTotal;
      let daySubtotal;

      if (isLastDay) {
        dayTotal = bookingTotal - accumulatedTotal;
        daySubtotal = bookingSubTotal - accumulatedSubTotal;
      } else {
        dayTotal = Math.round(bookingTotal * ratio);
        daySubtotal = Math.round(bookingSubTotal * ratio);
        accumulatedTotal += dayTotal;
        accumulatedSubTotal += daySubtotal;
      }

      const dayVat = dayTotal - daySubtotal;

      result[day._id] = {
        total: dayTotal,
        subtotal: daySubtotal,
        vat: dayVat,
      };
    });

    return result;
  }, [responseData?.days, responseData?.totalAmount, responseData?.subTotal]);

  const [submitLoading, setSubmitLoading] = useState(false);

  //receivable toggle
  const [receiableChange, setReceivableChange] = useState(false);

  const [notes, setNotes] = useState(responseData?.notes ?? "");
  const [editMode, setEditMode] = useState(false);

  // Keep local notes in sync with server when not editing (e.g. after save or booking switch)
  useEffect(() => {
    if (!editMode) {
      setNotes(responseData?.notes ?? "");
    }
  }, [responseData?._id, responseData?.notes, editMode]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openConfirmShowModal, setOpenConfirmShowModal] = useState(false);

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [facilityData, setFacilityData] = useState(responseData?.facility);
  const [image, openImage] = useState();
  const [images, setImages] = useState([]);
  const [dayToDelete, setDayToDelete] = useState(null);
  const [dayToEdit, setDayToEdit] = useState(null);
  const [deleteDayLoading, setDeleteDayLoading] = useState(false);
  
  // Modal states for refund/confirmation prompts
  const [refundModal, setRefundModal] = useState({ open: false, amount: 0, clientName: '', onConfirm: null, onCancel: null });
  const [confirmEditModal, setConfirmEditModal] = useState({ open: false, newTotal: 0, onConfirm: null, onCancel: null });
  const [deleteConfirmModal, setDeleteConfirmModal] = useState({
    open: false,
    date: "",
    timeRange: "",
    onConfirm: null,
    onCancel: null,
  });
  const [addDayModal, setAddDayModal] = useState(() => {
    const base = dayjs();
    return {
      open: false,
      dateValue: base,
      startTimeValue: base,
      endTimeValue: base.add(1, "hour"),
    };
  });
  const [addDayLoading, setAddDayLoading] = useState(false);

  // Lock the booking editing if any day is invoiced (cannot distribute or add totals to invoiced slots)
  const hasInvoicedDays = useMemo(() => {
    return Array.isArray(responseData?.days) && responseData.days.some((d) =>
      d?.status === 'show' || d?.status === 'invoiced' || d?.invoiced || d?.isInvoiced
    );
  }, [responseData?.days]);

  const currentDayData = useMemo(() => {
    if (!selectedAppointment || !responseData?.days?.length) return null;
    
    // slot
    if (selectedAppointment?.dayId) {
      const dayById = responseData.days.find((d) => d._id === selectedAppointment.dayId);
      if (dayById) {
        return dayById;
      }
    }
    
    if (selectedAppointment?.startTime && selectedAppointment?.endTime) {
      const dayByTime = responseData.days.find(
        (d) =>
          d.startTime === selectedAppointment.startTime &&
          d.endTime === selectedAppointment.endTime
      );
      if (dayByTime) {
        return dayByTime;
      }
    }
    
    return null;
  }, [selectedAppointment, responseData]);
  
  const otherBookings = useMemo(() => {
    if (!currentDayData || !responseData?.days?.length) {
      return responseData?.days || [];
    }
    return responseData.days.filter((d) => d._id !== currentDayData._id) || [];
  }, [currentDayData, responseData]);
  const dayId = currentDayData?._id;
  const currentDayLocked = useMemo(() => {
    if (!currentDayData) return false;
    return Boolean(
      currentDayData?.status === "show" ||
        currentDayData?.status === "invoiced" ||
        currentDayData?.invoiced ||
        currentDayData?.isInvoiced
    );
  }, [currentDayData]);
  const currentDayInvoiceTotal = dayId
    ? Number(dayFinancials?.[dayId]?.total) || 0
    : Number(responseData?.totalAmount) || 0;
  const handleReceivableChange = async (checked) => {
    setReceivableChange(true);
    try {
      if (!checked) {
        await http.put(`/bookings/${responseData?._id}/remove-receivable`);
        setResponseDate((prev) => ({ ...prev, receivable: false }));
        toast.success("Booking has been converted back to payment mode successfully");
      } else {
        await http.put(`/bookings/${responseData?._id}/make-receivable`);
        setResponseDate((prev) => ({ ...prev, receivable: true }));
        toast.success("Booking has been converted to receivable successfully");
      }
    } catch (error) {
      toast.error(error.response?.data.message || error.message || "Something went wrong");
    } finally {
      setReceivableChange(false);
    }
  };

  const handleSubmitDelete = async () => {
    if (!canDeleteBookings) {
      toast.error("You are not authorized to delete bookings.");
      return;
    }
    setDeleteLoading(true);
    try {
      await http.delete(`/bookings/${responseData?._id}`);
      setDeleteLoading(false);
      setOpenDeleteModal(false);
      toast.success("Booking has been deleted successfully");
      fetchAppointmentsData();
      setTimeout(() => {
        close();
      }, 1500);
    } catch (error) {
      setDeleteLoading(false);
      toast.error(error.response?.data.message || error.message || "Something went wrong");
    }
  };

  const handleDeleteDay = async (dayId) => {
    if (!canDeleteBookings) {
      toast.error("You are not authorized to delete booking days.");
      return;
    }
    setDeleteDayLoading(true);
    try {
      
      // if the day exists
      const dayToDelete = responseData?.days?.find((d) => d._id === dayId);
      if (!dayToDelete) {
        toast.error("Day not found.");
        setDeleteDayLoading(false);
        return;
      }
        const finalDayInvoiced = Boolean(
        dayToDelete?.status === 'show' ||
        dayToDelete?.status === 'invoiced' ||
        dayToDelete?.invoiced ||
        dayToDelete?.isInvoiced
      );
      
      if (finalDayInvoiced) {
        toast.error(`Cannot delete an invoiced day (${dayjs(dayToDelete?.date).format('MMM DD')}). It is locked.`);
        setDeleteDayLoading(false);
        return;
      }
      
      const remainingDays = responseData?.days?.filter((d) => d._id !== dayId);
      
      if (remainingDays.length === 0) {
        toast.error("Cannot delete the last day. Delete the entire booking instead.");
        setDeleteDayLoading(false);
        return;
      }
      
      const payload = {
        facility: responseData?.facility?._id,
        notes: responseData?.notes || "",
        // CRITICAL: Include _id for all days to preserve transaction links
        days: remainingDays.map((d) => ({
          _id: d._id, // Preserve _id to maintain transaction references
          date: dayjs(d.date).format("YYYY-MM-D"),
          startTime: d.startTime,
          endTime: d.endTime,
        })),
        images: responseData?.images || [],
      };
      
      // Check if this day is paid (but not invoiced) - per-day check
      const dayPaid = calculatePaidPerDay[dayId] || 0;
      const dayPaidButNotInvoiced = dayPaid > 0 && !finalDayInvoiced;
      
      // CRITICAL FIX: Refund should be the ACTUAL paid amount for this day, not the day's total
      // Only show refund prompt if day is actually paid (not 0/228)
      if (dayPaidButNotInvoiced && dayToDelete && dayPaid > 0) {
        // Refund amount is the actual amount paid for this specific day
        const refundAmount = Math.round(dayPaid);
        
        if (refundAmount > 0) {
          const clientName = responseData?.user?.name || "client";
          setRefundModal({
            open: true,
            amount: refundAmount,
            clientName: clientName,
            onConfirm: async () => {
              setRefundModal({ open: false, amount: 0, clientName: '', onConfirm: null, onCancel: null });
              await proceedWithDeleteDay(dayId, payload, refundAmount);
            },
            onCancel: () => {
              setRefundModal({ open: false, amount: 0, clientName: '', onConfirm: null, onCancel: null });
              setDeleteDayLoading(false);
            }
          });
          setDeleteDayLoading(false);
          return;
        }
      }
      
      await http.put(
        `/bookings/${responseData._id}/edit`,
        JSON.stringify(payload)
      );

      // Re-fetch authoritative booking and confirm deletion
      const fresh = await http.get(`/bookings/${responseData._id}`);
      const freshData = fresh?.data;
      const deletedDayStillExists = Array.isArray(freshData?.days) && freshData.days.some((d) => d._id === dayId);
      if (deletedDayStillExists) {
        toast.error("Delete failed: server blocked the deletion (day may be invoiced or policy-restricted).");
        setResponseDate(freshData);
        setDeleteDayLoading(false);
        return;
      }

      toast.success("Day deleted successfully");
      setResponseDate(freshData);

      if (getOpenAppointmentData) {
        await getOpenAppointmentData(responseData._id);
      } else if (fetchThisAppointmentData) {
        await fetchThisAppointmentData(responseData._id);
      }
      
      await fetchAppointmentsData();
      
    } catch (error) {
      
    const errorMessage = error.response?.data?.message || error.message || "Something went wrong";
      if (errorMessage.toLowerCase().includes('invoice') || errorMessage.toLowerCase().includes('invoiced')) {
        toast.error(`Cannot delete: This day is invoiced or the booking has invoiced days. ${errorMessage}`);
      } else {
        toast.error(`Delete failed: ${errorMessage}`);
      }
    } finally {
      setDeleteDayLoading(false);
    }
  };
  
  const proceedWithDeleteDay = async (dayId, payload, refundAmount = 0) => {
    setDeleteDayLoading(true);
    try {
      await http.put(
        `/bookings/${responseData._id}/edit`,
        JSON.stringify(payload)
      );

      // Re-fetch authoritative booking and confirm deletion
      const fresh = await http.get(`/bookings/${responseData._id}`);
      const freshData = fresh?.data;
      const deletedDayStillExists = Array.isArray(freshData?.days) && freshData.days.some((d) => d._id === dayId);
      if (deletedDayStillExists) {
        toast.error("Delete failed: server prevented deletion (day still present). ");
        setResponseDate(freshData);
        setDeleteDayLoading(false);
        return;
      }

      // Show appropriate success message based on whether refund was processed
      if (refundAmount > 0) {
        toast.success(`Day deleted successfully. ${prettyNumber(refundAmount)} EGP refunded to client's credit balance.`);
      } else {
        toast.success("Day deleted successfully");
      }
      setResponseDate(freshData);

      if (getOpenAppointmentData) {
        await getOpenAppointmentData(responseData._id);
      } else if (fetchThisAppointmentData) {
        await fetchThisAppointmentData(responseData._id);
      }
      
      await fetchAppointmentsData();
      
    } catch (error) {
      
      toast.error(error.response?.data.message || error.message || "Something went wrong");
    } finally {
      setDeleteDayLoading(false);
    }
  };

  const [showStatusLoading, setShowStatusLoading] = useState(false);
  const handelSubmitShow = async () => {
    setShowStatusLoading(true);
    try {
      await http.put(`bookings/${responseData?._id}/show/${dayId}`);
      
      setDeleteLoading(false);
      setOpenConfirmShowModal(false);
      
      await getOpenAppointmentData(responseData?._id);
      
      await fetchAppointmentsData();
      
      toast.success("Booking show successfully");
    } catch (error) {
      toast.error(error.response?.data.message || error.message || "Something went wrong");
    } finally {
      setShowStatusLoading(false);
    }
  };

  const bookingNotShow = async () => {
    try {
      setShowStatusLoading(true);
      await http.put(`/bookings/${responseData?._id}/no-show/${dayId}`);
      getOpenAppointmentData(responseData?._id);
      toast.success("Booking no show successfully");
    } catch (error) {
      toast.error(error.response?.data.message || error.message || "Something went wrong");
    } finally {
      setShowStatusLoading(false);
    }
  };

  // const handleDeleteImage = async (imageUrl) => {
  //   try {
  //     await http.delete(`/portal/bookings/${responseData?._id}/image`, {
  //       data: JSON.stringify({
  //         url: imageUrl,
  //       }),
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     // Update the local state to remove the image
  //     setResponseDate((prev) => ({
  //       ...prev,
  //       images: prev.images.filter((img) => img !== imageUrl),
  //     }));

  //     toast.success("Image deleted successfully");
  //   } catch (error) {
  //     toast.error(error.response?.data?.message || error.message || "Something went wrong");
  //   }
  // };

  useEffect(() => {
    if (responseData?.images && responseData?.images?.length > 0) {
      setImages(responseData?.images);
    }
  }, [responseData?.images]);

  const { components, setComponents } = useTimeSelection({ responseData });

  const bookingDuration = components.reduce(
    (prev, curr) => prev + diff_hours(curr?.endTimeValue, curr?.startTimeValue),
    0
  );

  const [pricing, setPricing] = useState({
    subTotal: null,
    vat: null,
    totalWithVat: null,
    wht: null,
    totalDiscounted: null,
  });

  const calcPrice = async () => {
    try {
      const result = await http.get(
        `/bookings/calc?facility=${facilityData?._id}&discount=${
          responseData?.discountType === "percentage"
            ? responseData?.discount
            : responseData?.discount
        }&discountType=${responseData?.discountType}&wht=${
          responseData?.whtPercent
        }&duration=${bookingDuration}&promoCodeId=${responseData?.promoCode}`
      );
      setPricing(result.data);
    } catch (error) {
      toast.error(error.response?.data?.message || error.message || "Something went wrong");
    }
  };

  useEffect(() => {
    if (editMode) {
      calcPrice();
    }
  }, [bookingDuration, editMode, facilityData?._id, components]);

  const editBooking = async ({ redirect = false }) => {
    try {
      setSubmitLoading(true);

      const allImages = [...images];

      const res = await http.put(
        `/bookings/${responseData._id}/edit`,
        JSON.stringify({
          facility: facilityData._id,
          notes: notes,
          days: components.map((c) => ({
            date: dayjs(c.dateValue).format("YYYY-MM-D"),
            startTime: dayjs(c.startTimeValue).unix(),
            endTime: dayjs(c.endTimeValue).unix(),
          })),
          images: allImages,
        })
      );
      if (getOpenAppointmentData) {
        await getOpenAppointmentData(responseData._id);
      } else if (fetchThisAppointmentData) {
        await fetchThisAppointmentData(responseData._id);
      }
      setEditMode(false);
      setImages([]);
      fetchAppointmentsData();
      if (redirect) {
        setSteps(1);
      } else {
        toast.success("Booking updated successfully");
      }
    } catch (error) {
      toast.error(error.response?.data.message || error.message || "Something went wrong");
    } finally {
      setSubmitLoading(false);
    }
  };

  const addNewComponent = () => {
    const newComponent = {
      dateValue: dayjs(),
      startTimeValue: dayjs(),
      endTimeValue: dayjs(),
    };
    setComponents([...components, newComponent]);
  };

  const removeComponent = (indexToRemove) => {
    const updatedComponents = components.filter((_, index) => index !== indexToRemove);
    setComponents(updatedComponents);
  };

  const buildAddDayDefaults = () => {
    const now = dayjs();
    const days = responseData?.days || [];
    const lastExistingDay = days[days.length - 1];

    if (lastExistingDay) {
      const defaultStart = dayjs.unix(lastExistingDay.endTime);
      const durationSeconds = Math.max(
        (lastExistingDay.endTime || 0) - (lastExistingDay.startTime || 0),
        3600
      );
      const defaultEnd = defaultStart.add(durationSeconds, "second");

      return {
        dateValue: defaultStart,
        startTimeValue: defaultStart,
        endTimeValue: defaultEnd,
      };
    }

    return {
      dateValue: now,
      startTimeValue: now,
      endTimeValue: now.add(1, "hour"),
    };
  };

  const openAddDayModal = () => {
    const defaults = buildAddDayDefaults();
    setAddDayModal({ open: true, ...defaults });
  };

  const closeAddDayModal = () => {
    const defaults = buildAddDayDefaults();
    setAddDayModal({ open: false, ...defaults });
  };

  const handleAddDayDateChange = (newValue) => {
    if (!newValue) return;
    setAddDayModal((prev) => {
      const currentDate = newValue.format("YYYY-MM-DD");
      const startTimeString = prev.startTimeValue?.format("THH:mm") || "T00:00";
      const endTimeString = prev.endTimeValue?.format("THH:mm") || "T01:00";

      const updatedStart = dayjs(currentDate + startTimeString);
      let updatedEnd = dayjs(currentDate + endTimeString);
      if (!updatedEnd.isAfter(updatedStart)) {
        updatedEnd = updatedStart.add(1, "hour");
      }

      return {
        ...prev,
        dateValue: newValue,
        startTimeValue: updatedStart,
        endTimeValue: updatedEnd,
      };
    });
  };

  const handleAddDayStartChange = (newValue) => {
    if (!newValue) return;
    setAddDayModal((prev) => {
      const baseDate =
        prev.dateValue?.format("YYYY-MM-DD") || newValue.format("YYYY-MM-DD");
      const startString = newValue.format("THH:mm");
      const endString = prev.endTimeValue?.format("THH:mm") || startString;

      const updatedStart = dayjs(baseDate + startString);
      let updatedEnd = dayjs(baseDate + endString);
      if (!updatedEnd.isAfter(updatedStart)) {
        updatedEnd = updatedStart.add(1, "hour");
      }

      return {
        ...prev,
        startTimeValue: updatedStart,
        endTimeValue: updatedEnd,
      };
    });
  };

  const handleAddDayEndChange = (newValue) => {
    if (!newValue) return;
    setAddDayModal((prev) => {
      const baseDate =
        prev.dateValue?.format("YYYY-MM-DD") || newValue.format("YYYY-MM-DD");
      const endString = newValue.format("THH:mm");
      let updatedEnd = dayjs(baseDate + endString);

      if (prev.startTimeValue && !updatedEnd.isAfter(prev.startTimeValue)) {
        updatedEnd = updatedEnd.add(1, "day");
      }

      return {
        ...prev,
        endTimeValue: updatedEnd,
      };
    });
  };

  const handleAddDaySubmit = async () => {
    if (!addDayModal.startTimeValue || !addDayModal.endTimeValue) {
      toast.error("Please select a start and end time.");
      return;
    }

    if (!addDayModal.endTimeValue.isAfter(addDayModal.startTimeValue)) {
      toast.error("End time must be after start time.");
      return;
    }

    const facilityId = facilityData?._id || responseData?.facility?._id;
    if (!facilityId) {
      toast.error("Facility information is missing.");
      return;
    }

    setAddDayLoading(true);
    try {
      // CRITICAL: Include _id for existing days to preserve transaction links
      // Without _id, backend generates new IDs and existing transaction dayIds become orphaned
      const existingDays =
        responseData?.days?.map((d) => ({
          _id: d._id, // Preserve existing day IDs to maintain transaction references
          date: dayjs(d.date).format("YYYY-MM-D"),
          startTime: d.startTime,
          endTime: d.endTime,
        })) || [];

      const newDayPayload = {
        date: addDayModal.startTimeValue.format("YYYY-MM-D"),
        startTime: addDayModal.startTimeValue.unix(),
        endTime: addDayModal.endTimeValue.unix(),
      };

      const payload = {
        facility: facilityId,
        notes: typeof notes === "string" ? notes : responseData?.notes || "",
        days: [...existingDays, newDayPayload],
        images: responseData?.images || [],
      };

      await http.put(
        `/bookings/${responseData._id}/edit`,
        JSON.stringify(payload)
      );

      const updatedBooking = await http.get(`/bookings/${responseData._id}`);

      if (getOpenAppointmentData) {
        await getOpenAppointmentData(responseData._id);
      } else if (fetchThisAppointmentData) {
        await fetchThisAppointmentData(responseData._id);
      }

      if (fetchAppointmentsData) {
        await fetchAppointmentsData();
      }

      if (updatedBooking?.data) {
        setResponseDate(updatedBooking.data);
        setSelectedBookingIds(
          updatedBooking.data?.days?.map((d) => d._id) || []
        );
      }

      toast.success("Booking slot added to wave.");
      closeAddDayModal();
    } catch (error) {
      toast.error(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    } finally {
      setAddDayLoading(false);
    }
  };


  const totalValues = editMode
    ? {
        subTotal: Number(pricing?.subTotal) || 0,
        vat: Number(pricing?.vat) || 0,
        wht: Number(pricing?.whtAmount) || 0,
        discountAmount: Number(pricing?.discountValue) || 0,
        discountValue: Number(pricing?.discountAmount) || 0,
        promoCode: Number(pricing?.promoCodeAmount) || 0,
        total: Number(pricing?.totalDiscounted) || 0,
      }
    : {
        subTotal: Number(responseData?.subTotal) || 0,
        vat: Number(responseData?.vat) || 0,
        wht: Number(responseData?.whtAmount) || 0,
        discountValue:
          responseData?.discountType === "percentage"
            ? Math.ceil((Number(responseData?.discount) / 100) * Number(responseData?.subTotal))
            : Number(responseData?.discount),
        discountAmount: Number(responseData?.discount) || 0,
        promoCode: Number(responseData?.promoCodeAmount) || 0,
        total: Number(responseData?.totalAmount) || 0,
      };

  // New state for multi-select bookings (after line 87)
  const [selectedBookingIds, setSelectedBookingIds] = useState(
    responseData?.days?.map((d) => d._id) || [] // default all selected
  );
  const allDays = responseData?.days || [];
  const allSelected = allDays.length > 0 && selectedBookingIds.length === allDays.length;

  // sync selectedBookingIds when responseData.days changes
  useEffect(() => {
    const currentDayIds = responseData?.days?.map((d) => d._id) || [];
    const validSelectedIds = selectedBookingIds.filter(id => currentDayIds.includes(id));
    if (validSelectedIds.length !== selectedBookingIds.length) {
      setSelectedBookingIds(validSelectedIds);
    }
  }, [responseData?.days]);

  const isInvalidAddDayRange =
    addDayModal?.endTimeValue && addDayModal?.startTimeValue
      ? !addDayModal.endTimeValue.isAfter(addDayModal.startTimeValue)
      : false;

  return (
    <>
      <ConfirmShowBooking
        selectedDay={currentDay}
        opened={openConfirmShowModal}
        setOpened={setOpenConfirmShowModal}
        loading={showStatusLoading}
        handelSubmitShow={handelSubmitShow}
        paidAmount={currentDayInvoiceTotal}
      />
      <DeleteModalBooking
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        deletedItem={"Booking"}
        loading={deleteLoading}
        handleSubmitDelete={handleSubmitDelete}
        deleteMessage={responseData?.days?.map((d, index) => (
          <li key={`${d.date}-${index}`}>
            {" "}
            {dayjs(d?.date).format("dddd")} {dayjs(d?.date).format("LL.")}{" "}
          </li>
        ))}
      />

      {steps === 0 ? (
        <div className="px-4 ">
          <div className="flex justify-between ">
            <div
              className="text-[32px] "
              style={{
                fontFamily: "gilroy-bold",
              }}
            >
              Booking
            </div>

            {/* Show or no show button */}
            <div className="flex gap-2 my-2 justify-end">
              {currentDayData?.status === "pending" ? (
                auth().role !== "Land Lord" && (
                  <>
                    {!responseData?.receivable && (() => {
                      const hasPaidDay = responseData?.days?.some((day) => {
                        const dayPaid = calculatePaidPerDay[day._id] || 0;
                        // calculate day total
                        const totalDuration = responseData.days?.reduce((sum, d) => sum + (d.endTime - d.startTime), 0) || 1;
                        const dayDuration = day.endTime - day.startTime;
                        const bookingTotal = Number(responseData?.totalAmount) || 0;
                        const dayTotal = Math.round((dayDuration / totalDuration) * bookingTotal);
                        return dayPaid > 0 && dayTotal > 0;
                      });
                      return hasPaidDay ? (
                      <button
                        disabled={showStatusLoading}
                        className="px-4 py-2 bg-[#00AD3B] disabled:bg-[#00AD3B60] text-white rounded-[10px] font-bold hover:opacity-90 hover:ring-1"
                        onClick={() => setOpenConfirmShowModal(true)}
                      >
                        Show
                      </button>
                      ) : null;
                    })()}
                    <button
                      disabled={showStatusLoading}
                      className="px-4 py-2 bg-[#9C0101] disabled:bg-[#9C010160] text-white rounded-[10px] font-bold hover:opacity-90 hover:ring-1"
                      onClick={bookingNotShow}
                    >
                      No show
                    </button>
                  </>
                )
              ) : (
                <>
                  {currentDayData?.status === "show" ? (
                    <div className="px-4 py-2 bg-[#00AD3B] text-white rounded-[10px] font-bold ">
                      Show
                    </div>
                  ) : (
                    <div className="px-4 py-2 bg-[#9C0101] text-white rounded-[10px] font-bold ">
                      No show
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="my-1 flex flex-col gap-3">
            <div className="flex items-center w-full justify-between mt-2">
              <div className="text-[18px] text-[#797979] font-semibold">Facility</div>
              <div className="flex gap-4 items-center">
                {auth().role !== "Land Lord" && (
                  currentDayLocked ? (
                    <span className="text-xs text-gray-500">🔒 Locked</span>
                  ) : (
                    <button
                      onClick={() => setEditMode(!editMode)}
                      className={` rounded-[10px] px-2 py-[2px] border-[1px] border-black transition-all ${
                        editMode
                          ? " bg-white text-black hover:bg-gray-100 "
                          : " bg-black text-white  hover:opacity-90 "
                      }`}
                    >
                      {editMode ? "Close" : "Edit"}
                    </button>
                  )
                )}
                {editMode && (
                  <button
                    onClick={() => editBooking({})}
                    className="bg-black text-white rounded-[10px] px-2 py-[2px]"
                  >
                    Save
                  </button>
                )}
              </div>
            </div>

            {editMode && responseData?.canUpdateDays ? (
              <div className=" mt-2  gap-[2px] relative w-full h-fit pt-4 pb-2 bg-white  ">
                <div className="absolute bg-white py-1 -top-4 text-[16px]  font-bold ">
                  Select Facility
                </div>

                <Carousel cols={2} rows={2} gap={5} loop style={{ padding: "50px" }}>
                  {facilities?.data?.map((item, index) => {
                    return (
                      <Carousel.Item key={index}>
                        <div
                          className={`  ml-3  p-1 cursor-pointer hover:bg-[#32b3be1a]  transition-all
                      ${facilityData._id === item._id ? "bg-[#32b3be1a] border-[#34B2C0]" : ""}
                        font-semibold
                        border-[1px] flex justify-start items-start py-2  ]
                        rounded-[10px] w-[200px] h-full `}
                          onClick={() => {
                            setFacilityData(item);
                          }}
                        >
                          <LazyLoadImage
                            height={70}
                            width={70}
                            src={item.mainImage}
                            alt={item.name}
                            className="w-[60px] h-[65px] object-cover rounded-[10px] "
                          />
                          {/* <img
                            height={70}
                            width={70}
                            loading="lazy"
                           
                          /> */}
                          <div className="flex flex-col justify-between   text-[14px]  h-full  mx-1">
                            <span className="font-bold ">{item.name}</span>
                            <span className="text-[#34B2C0]  text-[14px] underline ">
                              Quick View
                            </span>
                          </div>
                        </div>
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
              </div>
            ) : (
              <div className="border-[#E4E4E4] border-[1px] rounded-[10px] p-[6px] flex gap-3">
                <img
                  src={responseData?.facility?.mainImage}
                  alt={responseData?.facility?.name}
                  className="rounded-[10px] w-[100px] object-cover h-[75px] "
                />
                <div className="flex flex-col justify-between w-full  ">
                  <div className="text-[18px]  " style={{ fontFamily: "gilroy-bold" }}>
                    {responseData?.facility?.name}
                  </div>

                  <Link
                    to={`/inventory/facility/${responseData?.facility?._id}`}
                    className="text-[16px] text-[#34B2C0] underline"
                  >
                    Quick view
                  </Link>
                </div>
              </div>
            )}
          </div>
          <div className="my-2 flex flex-col gap-3">
            <div className="text-[#797979] text-[18px] font-semibold">Client information</div>
            <Link
              to={`/community/client/${responseData?.user?._id}`}
              className="border-[#E4E4E4] border-[1px] rounded-[10px] p-[6px] flex gap-3"
            >
              {responseData?.user?.profilePicture && (
                <img
                  src={responseData?.user?.profilePicture}
                  alt={responseData?.user?.name}
                  className="rounded-[10px] w-[65px] object-cover h-[65px] "
                />
              )}
              <div className="flex flex-col justify-center w-full  ">
                <div className="text-[18px] " style={{ fontFamily: "gilroy-bold" }}>
                  {responseData?.user?.name}
                </div>
                {responseData?.user?.company && (
                  <div className="text-[#797979]">
                    Member at " {responseData?.user?.company?.name}"
                  </div>
                )}
              </div>
            </Link>
          </div>
          {responseData?.editor && (
            <div className="my-2 flex flex-col gap-3">
              <div className="text-[#797979] text-[18px] font-semibold">Booked by</div>
              <Link
                target="_blank"
                to={
                  responseData?.editor?._id ? `/settings/admin/${responseData?.editor?._id}` : "#"
                }
                className="border-[#E4E4E4] border-[1px] rounded-[10px] p-[6px] flex gap-3"
              >
                <div className="flex flex-col justify-center w-full  ">
                  <div className="text-[18px] " style={{ fontFamily: "gilroy-bold" }}>
                    {responseData?.editor?.name || "n/a"}
                  </div>
                </div>
              </Link>
            </div>
          )}
          {responseData?.canUpdateDays && (
            <div className="flex justify-between items-center">
              <div className="w-full  my-2 bg-white py-1  text-[18px]  font-bold ">Unpaid</div>
              <Switch
                disabled={receiableChange}
                defaultChecked={responseData?.receivable ? Boolean(responseData.receivable) : false}
                onChange={(_, checked) => {
                  handleReceivableChange(checked);
                }}
              />
            </div>
          )}
          <div className="my-2 flex flex-col gap-3">
              <div className="text-[#797979] text-[18px] font-semibold">Bookings</div>
            <div className="border-[#E4E4E4] border-[1px] rounded-[10px] px-4 py-2 flex flex-col gap-4">
              {(() => {
                const renderDay = (d, { isSelected } = {}) => {
                  const dayFinancial = dayFinancials[d._id] || { total: 0, subtotal: 0, vat: 0 };
                  const dayTotal = dayFinancial.total;
                  const daySubtotal = dayFinancial.subtotal;
                  const dayVat = dayFinancial.vat;
                  // Get raw paid amount from allocation
                  const dayPaidRaw = Math.round(calculatePaidPerDay[d._id] || 0);
                  // CRITICAL FIX: Cap displayed paid amount at dayTotal
                  // When time is reduced on a day, a refund is issued and shown separately at the bottom
                  // The day should show as "fully paid" (paid = expected), not "overpaid"
                  // This prevents confusing display like (2,668 / 2,463) when refund was already issued
                  const dayPaid = Math.min(dayPaidRaw, dayTotal);
                  const dayRemaining = Math.max(0, dayTotal - dayPaid);
                  const finalDayInvoiced = Boolean(
                    d?.status === 'show' ||
                    d?.status === 'invoiced' ||
                    d?.invoiced ||
                    d?.isInvoiced
                  );
                  
                  // Use raw paid amount for determining if day is fully paid
                  // (if they paid at least the expected amount, it's fully paid)
                  const paidOk = dayPaidRaw >= dayTotal && dayTotal > 0;
                  const canPayThisDay = !responseData?.receivable && !finalDayInvoiced && dayRemaining > 0 && auth().role !== "Land Lord";
                  
                  // Green if fully paid, Red if unpaid
                  const colorClass = finalDayInvoiced || paidOk ? 'text-green-700 font-bold' : 'text-red-600 font-bold';
                  const canEdit = !finalDayInvoiced;
                  
                  const isClickable = !isSelected;
                  
                  const handleSelectDay = () => {
                    if (!isClickable) return;
                    setDayToEdit(null);
                    setOpenConfirmShowModal(false);
                    if (typeof onSelectBookingDay === "function") {
                      onSelectBookingDay(responseData?._id, d?._id);
                    }
                  };
                  
                  const handlePayThisDay = () => {
                    setSelectedDayIdForPayment(d._id);
                    setSteps(1);
                  };
                  
                  return (
                    <li
                      key={d._id}
                      className="flex items-center justify-between gap-2 py-1"
                    >
                      <span
                        className={`${isClickable ? "underline cursor-pointer hover:text-blue-600" : ""}`}
                        onClick={handleSelectDay}
                      >
                        {dayjs(d?.date).format("dddd, MMM DD YYYY")}{" "}
                        {dayjs(d?.startTime * 1000).format("LT")} - {dayjs(d?.endTime * 1000).format("LT")}
                      </span>
                      <div className="flex items-center gap-2">
                        <span className={`text-[14px] ${colorClass}`}>
                          ({prettyNumber(dayPaid)} / {prettyNumber(dayTotal)})
                        </span>
                        {canPayThisDay && (
                          <button
                            className="text-xs px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
                            onClick={handlePayThisDay}
                            title={`Pay ${prettyNumber(dayRemaining)} EGP for this day`}
                          >
                            Pay Day
                          </button>
                        )}
                        {canEdit ? (
                          <>
                            <button
                              className="text-xs text-blue-600 hover:underline"
                              onClick={() => setDayToEdit(d)}
                              disabled={deleteDayLoading}
                            >
                              Edit
                            </button>
                            {canDeleteBookings ? (
                              <button
                                className="text-xs text-red-600 hover:underline"
                                onClick={() => {
                                  const dateLabel = dayjs(d?.date).format("MMM DD, YYYY");
                                  const timeRange = `${dayjs(d?.startTime * 1000).format("LT")} - ${dayjs(
                                    d?.endTime * 1000
                                  ).format("LT")}`;
                                  setDeleteConfirmModal({
                                    open: true,
                                    date: dateLabel,
                                    timeRange,
                                    onConfirm: () => {
                                      setDeleteConfirmModal({
                                        open: false,
                                        date: "",
                                        timeRange: "",
                                        onConfirm: null,
                                        onCancel: null,
                                      });
                                      handleDeleteDay(d._id);
                                    },
                                  });
                                }}
                                disabled={deleteDayLoading}
                              >
                                {deleteDayLoading ? "Deleting..." : "Delete"}
                              </button>
                            ) : null}
                          </>
                        ) : (
                          <span className="text-xs text-gray-500">🔒 Locked</span>
                        )}
            </div>
                    </li>
                  );
                };

                        return (
                  <>
                    {currentDayData && (
                      <div className="flex flex-col gap-2">
                        <div className="text-[#797979] text-[16px] font-semibold">Selected Day</div>
                        <ul className="list-none p-0 m-0 flex flex-col gap-2">
                          {renderDay(currentDayData, { isSelected: true })}
                        </ul>
                      </div>
                    )}

                    {otherBookings && otherBookings.length > 0 && (
                      <div className="flex flex-col gap-2">
                        <div className="text-[#797979] text-[16px] font-semibold">Other Bookings</div>
                        <ul className="list-none p-0 m-0 flex flex-col gap-2">
                          {otherBookings.map((d) => renderDay(d, { isSelected: false }))}
                        </ul>
                      </div>
                    )}
                  </>
                );
              })()}
            </div>
          </div>

          {responseData?.canUpdateDays && !hasInvoicedDays && (
            <div className="flex justify-start mt-2">
              <Button onClick={openAddDayModal}>Add Booking to Wave</Button>
            </div>
          )}

          <ModalComponent
            opened={addDayModal.open}
            setOpened={(open) => {
              if (!open && !addDayLoading) {
                closeAddDayModal();
              }
            }}
          >
            <div className="p-6 flex flex-col gap-4">
              <h2 className="text-xl font-bold">Add Booking to Wave</h2>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="flex flex-col gap-3">
                  <DatePicker
                    label="Date"
                    value={addDayModal.dateValue}
                    onChange={handleAddDayDateChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  <TimePicker
                    label="Start Time"
                    value={addDayModal.startTimeValue}
                    onChange={handleAddDayStartChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  <TimePicker
                    label="End Time"
                    value={addDayModal.endTimeValue}
                    onChange={handleAddDayEndChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </div>
              </LocalizationProvider>
              {isInvalidAddDayRange && (
                <p className="text-sm text-red-600">End time must be after start time.</p>
              )}
              <div className="flex gap-3 justify-end">
                <Button
                  secondary={true}
                  invert={true}
                  onClick={closeAddDayModal}
                  disabled={addDayLoading}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleAddDaySubmit}
                  loading={addDayLoading}
                  disabled={isInvalidAddDayRange}
                >
                  Add
                </Button>
              </div>
            </div>
          </ModalComponent>

          {/* Edit Day Modal */}
          {dayToEdit && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-md w-full">
                <h3 className="text-lg font-bold mb-4">Edit Day</h3>
                <div className="flex flex-col gap-4">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="Date"
                      value={dayjs(dayToEdit.date)}
                      onChange={(newValue) => {
                        if (!newValue) return;
                        setDayToEdit((prev) => {
                          const newDate = dayjs(newValue);
                          const currentStart = dayjs.unix(prev.startTime);
                          const currentEnd = dayjs.unix(prev.endTime);
                          
                          const updatedStart = currentStart
                            .year(newDate.year())
                            .month(newDate.month())
                            .date(newDate.date());
                          
                          const updatedEnd = currentEnd
                            .year(newDate.year())
                            .month(newDate.month())
                            .date(newDate.date());
                          
                          return {
                            ...prev,
                            date: newDate.toISOString(),
                            startTime: updatedStart.unix(),
                            endTime: updatedEnd.unix(),
                          };
                        });
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                              <TimePicker
                      label="Start Time"
                      value={dayjs(dayToEdit.startTime * 1000)}
                      onChange={(newValue) => setDayToEdit({...dayToEdit, startTime: newValue.unix()})}
                      renderInput={(params) => <TextField {...params} />}
                    />
                              <TimePicker
                      label="End Time"
                      value={dayjs(dayToEdit.endTime * 1000)}
                      onChange={(newValue) => setDayToEdit({...dayToEdit, endTime: newValue.unix()})}
                      renderInput={(params) => <TextField {...params} />}
                              />
                            </LocalizationProvider>
                  <div className="flex gap-2 justify-end mt-4">
                    <button
                      className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                      onClick={() => setDayToEdit(null)}
                    >
                      Cancel
                            </button>
                    <button
                      className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                      onClick={async () => {
                        try {
                          // CRITICAL: Include _id for all days to preserve transaction links
                          const updatedDays = responseData?.days?.map((d) =>
                            d._id === dayToEdit._id
                              ? {
                                  _id: d._id, // Preserve _id to maintain transaction references
                                  date: dayjs(dayToEdit.date).format("YYYY-MM-D"),
                                  startTime: dayToEdit.startTime,
                                  endTime: dayToEdit.endTime,
                                }
                              : {
                                  _id: d._id, // Preserve _id to maintain transaction references
                                  date: dayjs(d.date).format("YYYY-MM-D"),
                                  startTime: d.startTime,
                                  endTime: d.endTime,
                                }
                          );

                          const payload = {
                            facility: responseData?.facility?._id,
                            notes: responseData?.notes || "",
                            days: updatedDays,
                            images: responseData?.images || [],
                          };

                          const response = await http.put(
                            `/bookings/${responseData._id}/edit`,
                            JSON.stringify(payload)
                          );

                          toast.success("Day updated successfully. Recalculating pricing...");
                          
                          // Calculate total duration from all days
                          let totalDuration = 0;
                          updatedDays.forEach((day) => {
                            const seconds = Math.abs((day.endTime || 0) - (day.startTime || 0));
                            const slots = Math.abs(Math.ceil(seconds / (60 * 30))) || 0;
                            totalDuration += slots;
                          });
                          
                          const calcResponse = await http.get(
                            `/bookings/calc?facility=${responseData?.facility?._id}&discount=${
                              responseData?.discount || 0
                            }&duration=${totalDuration}&wht=${
                              responseData?.whtPercent || 0
                            }&discountType=${
                              responseData?.discountType || "percentage"
                            }&promoCodeId=${
                              responseData?.promoCode?._id || ""
                            }${responseData?.exemptVat ? "&exemptVat=true" : ""}`
                          );
                          const originalDay = responseData?.days?.find(d => d._id === dayToEdit._id);
                          
                          if (!originalDay) {
                            toast.error("Day not found in booking data.");
                            setDayToEdit(null);
                            return;
                          }
                          
                          const finalDayInvoiced = Boolean(
                            originalDay?.status === 'show' ||
                            originalDay?.status === 'invoiced' ||
                            originalDay?.invoiced ||
                            originalDay?.isInvoiced
                          );
                          
                          // if day is invoiced, don't allow edit
                          if (finalDayInvoiced) {
                            toast.error(`Cannot edit an invoiced day (${dayjs(originalDay?.date).format('MMM DD')}). It is locked.`);
                            setDayToEdit(null);
                            return;
                          }
                          
                          // Check if THIS SPECIFIC DAY is paid (but not invoiced)
                          const dayPaid = calculatePaidPerDay[dayToEdit._id] || 0;
                          const dayPaidButNotInvoiced = dayPaid > 0 && !finalDayInvoiced;
                          
                          // duration is same (just time changed) = no refund needed
                          const oldDayDuration = originalDay.endTime - originalDay.startTime;
                          const newDayDuration = dayToEdit.endTime - dayToEdit.startTime;
                          const oldDayDurationHours = oldDayDuration / 3600;
                          const newDayDurationHours = newDayDuration / 3600;
                          const durationChanged = oldDayDuration !== newDayDuration;
                          
                          const oldTotal = Number(responseData?.totalAmount) || 0;
                          const newTotal = Number(calcResponse.data.totalDiscounted) || 0;
                          
                          const oldTotalDuration = responseData?.days?.reduce((sum, d) => sum + (d.endTime - d.startTime), 0) || 1;
                          const oldDayRatio = oldTotalDuration > 0 ? oldDayDuration / oldTotalDuration : 0;
                          const oldDayTotal = Math.round(oldTotal * oldDayRatio);
                          
                          const newTotalDuration = updatedDays.reduce((sum, d) => sum + (d.endTime - d.startTime), 0) || 1;
                          const newDayRatio = newTotalDuration > 0 ? newDayDuration / newTotalDuration : 0;
                          const newDayTotal = Math.round(newTotal * newDayRatio);
                          
                          const diffDayTotal = newDayTotal - oldDayTotal;
                          
                          // Helper function to complete edit save
                          const completeEditSave = async (refundAmountForMessage = 0) => {
                            // First fetch fresh data from backend
                            const updatedBooking = await http.get(`/bookings/${responseData._id}`);
                            
                            // CRITICAL: Force refresh by calling parent's refresh function FIRST
                            // This ensures ogRespone prop gets updated, which triggers useEffect to sync responseData
                            if (getOpenAppointmentData) {
                              await getOpenAppointmentData(responseData._id);
                            } else if (fetchThisAppointmentData) {
                              await fetchThisAppointmentData(responseData._id);
                            }
                            
                            // Also refresh calendar list
                            await fetchAppointmentsData();
                            
                            // Use fetched data immediately
                            if (updatedBooking?.data) {
                              setResponseDate(updatedBooking.data);
                            }
                            
                            // Show appropriate success message based on whether refund was processed
                            if (refundAmountForMessage > 0) {
                              toast.success(`Day updated successfully. ${prettyNumber(refundAmountForMessage)} EGP refunded to client's credit balance.`);
                            } else {
                              toast.success("Pricing updated successfully!");
                            }
                            setDayToEdit(null);
                          };
                                  
                          // CRITICAL FIX: Only show refund if day is actually paid and duration decreased
                          // Refund amount should be based on actual paid amount, not day total
                          if (dayPaidButNotInvoiced && durationChanged && diffDayTotal !== 0 && dayPaid > 0) {
                            if (newDayDuration < oldDayDuration && diffDayTotal < 0) {
                              // Calculate refund: if new day total is less than what was paid, refund the difference
                              // But don't refund more than what was actually paid
                              const refundAmount = Math.min(Math.abs(diffDayTotal), dayPaid);
                              const needsRefund = refundAmount > 0.5;
                              if (needsRefund) {
                                const clientName = responseData?.user?.name || "client";
                                setRefundModal({
                                  open: true,
                                  amount: refundAmount,
                                  clientName: clientName,
                                  onConfirm: async () => {
                                    setRefundModal({ open: false, amount: 0, clientName: '', onConfirm: null, onCancel: null });
                                    await completeEditSave(refundAmount);
                                  },
                                  onCancel: () => {
                                    setRefundModal({ open: false, amount: 0, clientName: '', onConfirm: null, onCancel: null });
                                    setDayToEdit(null);
                                  }
                                });
                                return;
                              }
                            } else {
                              setConfirmEditModal({
                                open: true,
                                newTotal: newTotal,
                                onConfirm: async () => {
                                  setConfirmEditModal({ open: false, newTotal: 0, onConfirm: null, onCancel: null });
                                  await completeEditSave();
                                },
                                onCancel: () => {
                                  setConfirmEditModal({ open: false, newTotal: 0, onConfirm: null, onCancel: null });
                                  setDayToEdit(null);
                                }
                              });
                              return;
                            }
                          } else if (dayPaidButNotInvoiced && !durationChanged) {
                            await completeEditSave();
                            return;
                          }
                          
                          // No confirmation needed, proceed directly
                          await completeEditSave();
                        } catch (error) {
                          // Check if error is related to invoicing
                          const errorMessage = error.response?.data?.message || error.message || "Something went wrong";
                          if (errorMessage.toLowerCase().includes('invoice') || errorMessage.toLowerCase().includes('invoiced')) {
                            toast.error(`Cannot edit: This day is invoiced or the booking has invoiced days. ${errorMessage}`);
                          } else {
                            toast.error(`Edit failed: ${errorMessage}`);
                          }
                          setDayToEdit(null);
                        }
                      }}
                    >
                      Save
                    </button>
                </div>
                </div>
                </div>
                </div>
          )}

            {/* Notes: read-only in view mode; editable in edit mode (backend max 500 chars) */}
          {(responseData?.notes || editMode) && (
            <div>
              <div className="text-[#797979] text-[18px] font-semibold mt-3 mb-2">Notes</div>
              {editMode ? (
                <TextField
                  fullWidth
                  multiline
                  minRows={4}
                  maxRows={12}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Add notes for this booking..."
                  variant="outlined"
                  inputProps={{ maxLength: 500 }}
                />
              ) : (
                <div className="border-[#E4E4E4] border-[1px] rounded-[10px] px-4 py-2 flex flex-col gap-2">
                  {responseData?.notes}
                </div>
              )}
            </div>
          )}

          {/* Images Section */}
          {responseData?.images?.filter(isImageFile)?.length > 0 && !editMode && (
            <div className="mt-[15px] flex flex-col pb-2">
              <div className="text-[#011516] text-[18px] " style={{ fontFamily: "gilroy-bold" }}>
                Images
              </div>
              <div className="flex gap-3 flex-nowrap overflow-x-auto">
                {responseData?.images?.filter(isImageFile)?.map((img, i) => {
                  return (
                    <div key={i} className="relative">
                      <img
                        className="w-52 h-60 object-contain cursor-pointer"
                        src={img}
                        alt=""
                        onClick={() => openImage(img)}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Documents Section */}
          {responseData?.images?.filter((url) => !isImageFile(url))?.length > 0 && !editMode && (
            <div className="mt-[15px] flex flex-col pb-2">
              <div className="text-[#011516] text-[18px] " style={{ fontFamily: "gilroy-bold" }}>
                Documents
              </div>
              <div className="flex gap-3 flex-wrap">
                {responseData?.images
                  ?.filter((url) => !isImageFile(url))
                  ?.map((doc, i) => {
                    return (
                      <div
                        key={i}
                        className="border-[#E4E4E4] border-[1px] rounded-[10px] p-3 flex flex-col items-center gap-2 min-w-[120px]"
                      >
                        <div className="w-12 h-12 bg-[#F6F8F7] rounded-[8px] flex items-center justify-center">
                          <span className="text-[12px] font-bold text-[#797979]">
                            {getFileExtension(doc)}
                          </span>
                        </div>

                        <button
                          onClick={() => window.open(doc, "_blank")}
                          className="text-[12px] text-[#34B2C0] underline hover:no-underline cursor-pointer"
                        >
                          Download
                        </button>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
          <div className="mt-6 bg-[#F6F8F7] py-2 px-4 w-full rounded-[10px] flex flex-col">
            <div
              className="mt-4"
              style={{
                display: "grid",
                gridTemplateColumns: "auto auto auto",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <span className="w-[80px] text-[18px] font-bold">Subtotal</span>
              <div className="flex items-center">
                <span className="text-[18px] text-[#797979]">
                  {prettyNumber(+totalValues.subTotal)} EGP
                </span>
              </div>
              <div></div>

              <span className="w-[80px] text-[18px] font-bold">VAT</span>
              <div className="flex items-center">
                <span className="text-[18px] text-[#797979]">
                  {prettyNumber(+totalValues.vat)} EGP
                </span>
              </div>
              <div></div>

              <span className="w-[80px] text-[18px] font-bold">WHT</span>
              <div className="flex items-center">
                <span className="text-[18px] text-[#797979]">
                  {prettyNumber(+totalValues.wht)} EGP
                </span>
              </div>
              <div></div>

              {(totalValues?.discountValue &&
                !isNaN(totalValues?.discountValue) &&
                Number(totalValues?.discountValue) > 0) ||
              true ? (
                <>
                  <span className="w-[80px] text-[18px] font-bold">Discount</span>
                  <div className="flex items-center">
                    <span className="text-[18px] text-[#797979]">
                      -{prettyNumber(+totalValues?.discountValue)} EGP
                      {responseData?.discountType === "percentage"
                        ? ` (${
                            prettyNumber(
                              (totalValues?.discountValue / totalValues?.subTotal) * 100
                            ) + " %"
                          })`
                        : null}
                    </span>
                  </div>
                  <div></div>
                </>
              ) : null}

              {responseData?.promoCodeAmount &&
              !isNaN(responseData?.promoCodeAmount) &&
              Number(responseData?.promoCodeAmount) > 0 ? (
                <>
                  <span className="w-[80px] text-[18px] font-bold">Promo Code</span>
                  <div className="flex items-center">
                    <span className="text-[18px] text-[#797979]">
                      -{prettyNumber(+totalValues.promoCode)} EGP (
                      {+((totalValues.promoCode / totalValues?.subTotal) * 100).toFixed(2)} %)
                    </span>
                  </div>
                  <div></div>
                </>
              ) : null}

              {responseData?.totalRefunded &&
              !isNaN(responseData?.totalRefunded) &&
              Number(responseData?.totalRefunded) > 0 ? (
                <>
                  <span className="w-[80px] text-[18px] font-bold">Refunded</span>
                  <div className="flex items-center">
                    <span className="text-[18px] text-[#797979]">
                      -{prettyNumber(+responseData.totalRefunded)} EGP
                    </span>
                  </div>
                  <div></div>
                </>
              ) : null}
            </div>

            <div className="mt-4 text-[18px]">Amount paid</div>

            <div className="flex flex-col gap-1">
              <div className="flex items-center text-[18px] gap-2">
              <div className="text-[#011516] text-[25px] " style={{ fontFamily: "gilroy-bold" }}>
                {prettyNumber(calculateTotalPaid() > totalValues.total ? totalValues.total : calculateTotalPaid())} EGP
              </div>
              <div className="text-[#797979]">from</div>
              <div className="text-[#011516] text-[25px] " style={{ fontFamily: "gilroy-bold" }}>
                {prettyNumber(+totalValues.total)} EGP
              </div>
              </div>
              {/* show refund amount if paid > total */}
              {calculateTotalPaid() > totalValues.total && (
                <div className="text-[14px] text-orange-600 font-semibold mt-1">
                  Refund: {prettyNumber(calculateTotalPaid() - totalValues.total)} EGP to {responseData?.user?.name || "client"}'s credit balance
                </div>
              )}
            </div>
          </div>
          <div className="flex w-full justify-end  mt-4 gap-5 pb-6">
            {canDeleteBookings && responseData?.canUpdateDays ? (
              <Button secondary={true} invert={true} onClick={() => setOpenDeleteModal(true)}>
                Delete
              </Button>
            ) : null}
            {calculateTotalPaid() >= responseData.totalWithDiscount
              ? auth().role !== "Land Lord" && (
                  <Button disabled secondary={true}>
                    Completed
                  </Button>
                )
              : auth().role !== "Land Lord" &&
                (responseData?.totalWithDiscount > calculateTotalPaid() &&
                !responseData?.receivable ? (
                  <Button
                    loading={submitLoading}
                    type="submit"
                    secondary={true}
                    onClick={() => {
                      setSelectedDayIdForPayment(null); // Clear any day selection for "Pay All"
                      setSteps(1);
                    }}
                  >
                    Pay now
                  </Button>
                ) : null)}
          </div>
        </div>
      ) : (
        <CalendarFormStep2
          subTotal={responseData?.subTotal}
          vat={responseData?.vat}
          total={responseData?.totalAmount - calculateTotalPaid()}
          discount={responseData?.discount}
          amountPaid={calculateTotalPaid()}
          responseData={responseData}
          selectedTimeSlotData={selectedTimeSlotData}
          open={open}
          close={() => {
            setSelectedDayIdForPayment(null);
            close();
          }}
          facilities={facilities}
          paymentMethods={paymentMethods}
          fetchAppointmentsData={fetchAppointmentsData}
          dayId={selectedDayIdForPayment}
        />
      )}

      {/* Image Display Modal */}
      <ModalComponent
        size={"100%"}
        opened={Boolean(image)}
        setOpened={openImage}
        onClose={() => openImage("")}
      >
        <div className="flex justify-center flex-col items-center gap-[25px]">
          <img className="w-full h-full max-w-[80%] max-h-[80%]" src={image} alt="" />
          <div className="flex  gap-[40px]">
            <Button onClick={() => openImage("")} secondary={true} invert={true}>
              Close
            </Button>
          </div>
        </div>
      </ModalComponent>

      {/* Refund Confirmation Modal */}
      <ModalComponent
        opened={refundModal.open}
        setOpened={(open) => {
          if (!open) {
            if (refundModal.onCancel) {
              refundModal.onCancel();
            } else {
              setRefundModal({ open: false, amount: 0, clientName: '', onConfirm: null, onCancel: null });
            }
          }
        }}
      >
        <div className="p-6 flex flex-col gap-4">
          <h2 className="text-xl font-bold">Refund Confirmation</h2>
          <p className="text-gray-700">
            Refund {prettyNumber(refundModal.amount)} EGP to {refundModal.clientName}'s credit balance?
          </p>
          <div className="flex gap-3 justify-end mt-4">
            <Button
              secondary={true}
              invert={true}
              onClick={() => {
                if (refundModal.onCancel) {
                  refundModal.onCancel();
                } else {
                  setRefundModal({ open: false, amount: 0, clientName: '', onConfirm: null, onCancel: null });
                }
              }}
            >
              No
            </Button>
            <Button
              onClick={() => {
                if (refundModal.onConfirm) refundModal.onConfirm();
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      </ModalComponent>

      {/* Edit Confirmation Modal */}
      <ModalComponent
        opened={confirmEditModal.open}
        setOpened={(open) => {
          if (!open && confirmEditModal.onCancel) {
            confirmEditModal.onCancel();
          } else if (!open) {
            setConfirmEditModal({ open: false, newTotal: 0, onConfirm: null, onCancel: null });
          }
        }}
      >
        <div className="p-6 flex flex-col gap-4">
          <h2 className="text-xl font-bold">Confirm Total Change</h2>
          <p className="text-gray-700">
            Note: the updated booking total is now {prettyNumber(confirmEditModal.newTotal)} EGP.
          </p>
          <div className="flex gap-3 justify-end mt-4">
            <Button
              secondary={true}
              invert={true}
              onClick={() => {
                if (confirmEditModal.onCancel) confirmEditModal.onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (confirmEditModal.onConfirm) confirmEditModal.onConfirm();
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      </ModalComponent>

      {/* Delete Confirmation Modal */}
      <ModalComponent
        opened={deleteConfirmModal.open}
        setOpened={(open) => {
          if (!open && deleteConfirmModal.onCancel) {
            deleteConfirmModal.onCancel();
          } else if (!open) {
            setDeleteConfirmModal({ open: false, date: "", timeRange: "", onConfirm: null, onCancel: null });
          }
        }}
      >
        <div className="p-6 flex flex-col gap-4">
          <h2 className="text-xl font-bold">Delete Booking</h2>
          <p className="text-gray-700">
            Delete booking on {deleteConfirmModal.date}
            {deleteConfirmModal.timeRange ? ` ${deleteConfirmModal.timeRange}` : ""}?
          </p>
          <div className="flex gap-3 justify-end mt-4">
            <Button
              secondary={true}
              invert={true}
              onClick={() => {
                if (deleteConfirmModal.onCancel) deleteConfirmModal.onCancel();
                else setDeleteConfirmModal({ open: false, date: "", timeRange: "", onConfirm: null, onCancel: null });
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (deleteConfirmModal.onConfirm) deleteConfirmModal.onConfirm();
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

export default BookingsDetails;
